var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 2C12.75 1.58579 12.4142 1.25 12 1.25C11.5858 1.25 11.25 1.58579 11.25 2V8C11.25 8.41421 11.5858 8.75 12 8.75C12.4142 8.75 12.75 8.41421 12.75 8V2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00545 5.65466C8.36701 5.45254 8.49626 4.9956 8.29415 4.63404C8.09203 4.27248 7.63509 4.14323 7.27353 4.34534C4.27745 6.02018 2.25 9.23911 2.25 12.9333C2.25 18.3497 6.61001 22.75 12 22.75C17.39 22.75 21.75 18.3497 21.75 12.9333C21.75 9.23911 19.7225 6.02018 16.7265 4.34534C16.3649 4.14323 15.908 4.27248 15.7059 4.63404C15.5037 4.9956 15.633 5.45254 15.9945 5.65466C18.5322 7.0732 20.25 9.8003 20.25 12.9333C20.25 17.5317 16.5511 21.25 12 21.25C7.44886 21.25 3.75 17.5317 3.75 12.9333C3.75 9.8003 5.46784 7.0732 8.00545 5.65466Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerSwitch);
export default __webpack_public_path__ + "static/media/power-switch.3d732dd46988d6f422b31214c391eae8.svg";
export { ForwardRef as ReactComponent };